import { LayoutMode } from '../../../components/layout-buttons/types';
import { SET_PRODUCT_COLLECTION_LAYOUT } from '../actions';
import { PRODUCT_COLLECTION_LAYOUT } from '../constants';

type State = {
  userSelectedLayout?: LayoutMode;
  /**
   * ProductCollection.stateToVariables for the last 5 product collections
   */
  lastFilters?: { id: string; state: any }[];
};

export default (state: State | undefined = {}, action: any): State => {
  switch (action.type) {
    case 'ROUTE_LOADED': {
      return {
        ...state,
      };
    }

    case SET_PRODUCT_COLLECTION_LAYOUT:
      return {
        ...state,
        userSelectedLayout: action.layout,
      };

    case 'LOCAL_STORAGE_RECEIVE': {
      const productCollectionLayoutFromLocalStorage =
        action.localStorageState[PRODUCT_COLLECTION_LAYOUT];

      return {
        ...state,
        userSelectedLayout:
          typeof productCollectionLayoutFromLocalStorage !== 'undefined' &&
          // Don't set `userSelectedLayout` if localStorage contains a faulty or removed value
          Object.values(LayoutMode).includes(
            productCollectionLayoutFromLocalStorage
          )
            ? productCollectionLayoutFromLocalStorage
            : undefined,
      };
    }
    default:
      break;
  }

  return state;
};
